var map = {
	"./AzureOpenAIAPIBotSettings": 2669,
	"./AzureOpenAIAPIBotSettings.vue": 2669,
	"./BardBotSettings": 5538,
	"./BardBotSettings.vue": 5538,
	"./BingChatBotSettings": 402,
	"./BingChatBotSettings.vue": 402,
	"./ChatGPTBotSettings": 9762,
	"./ChatGPTBotSettings.vue": 9762,
	"./GradioAppBotSettings": 5928,
	"./GradioAppBotSettings.vue": 5928,
	"./HuggingChatBotSettings": 4531,
	"./HuggingChatBotSettings.vue": 4531,
	"./LMSYSBotSettings": 8797,
	"./LMSYSBotSettings.vue": 8797,
	"./LoginSetting": 5562,
	"./LoginSetting.vue": 5562,
	"./MOSSBotSettings": 4899,
	"./MOSSBotSettings.vue": 4899,
	"./OpenAIAPIBotSettings": 7272,
	"./OpenAIAPIBotSettings.vue": 7272,
	"./PoeBotSettings": 5982,
	"./PoeBotSettings.vue": 5982,
	"./QianWenBotSettings": 4575,
	"./QianWenBotSettings.vue": 4575,
	"./SkyWorkBotSettings": 1927,
	"./SkyWorkBotSettings.vue": 1927,
	"./SparkBotSettings": 1043,
	"./SparkBotSettings.vue": 1043,
	"./WenxinQianfanBotSettings": 1736,
	"./WenxinQianfanBotSettings.vue": 1736
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2124;
module.exports = webpackAsyncContext;